<template>

  <div class="header clearfix">
    <div class="logo">
      <router-link to="/">
        <img alt="logo" src="@/assets/logo.png">
      </router-link>
    </div>
    <div class="header_meta">
      <div class="lang">
        <select name="lang">
          <option value="">AR</option>
          <option value="">EN</option>
        </select>
      </div>
      <div class="user_info">
        <span class="auth_user">إسم المستخدم</span>
        <span class="avatar"><img src="@/assets/images/profile.png" alt=""></span>
      </div>
      <div class="notification_area">
        <img src="@/assets/images/notification.png" alt="">
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "Header",
  }
</script>

<style lang="scss" scoped>
.header {
  padding: 20px 40px;
  background-color: #fff;
  position: fixed;
  z-index: 99999;
  height: 130px;
  width: 100%;
  .logo {
    float: right;
    margin-bottom: 0px !important;
    img {
      max-width: 160px;
    }
  }
  nav {
    float: left;
    padding: 40px 0;
  }
  .header_meta {
    display: inline-flex;
    align-items: center;
    padding: 25px 0;
    float: left;
    .lang {
      select {
        padding: 2px 18px;
        border-radius: 20px;
      }
    }
    .user_info {
      margin: 0 20px;
      padding: 0 20px;
      border-right: 1px solid #E0E0E0;
      border-left: 1px solid #E0E0E0;
      .auth_user {
        margin-left: 15px;
        font-weight: 600;
        font-size: 14px;
      }
    }
    .notification_area {
      cursor: pointer;
    }
  }
}
</style>
